import { useEffect, useState } from 'react';

import { Button, Dialog, Field, Textarea } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { usePhatHanh } from '../hooks/useThamDinh';
import type { BoTieuChiChiTiet } from '../types';

export interface HopPhatHanhProps {
  open: boolean;
  onClose: () => void;
  bo: BoTieuChiChiTiet;
}

/**
 * Phát hành một phiên bản bộ tiêu chí.
 *
 * Bản phát hành là **bất biến** (đặc tả mục 2.4): hồ sơ chấm theo bản nào thì sáu tháng sau vẫn tái lập được
 * đúng bản đó. Nên thân hộp nói rõ điều này — người dùng cần biết đây không phải một lần lưu nữa.
 */
export function HopPhatHanh({ open, onClose, bo }: HopPhatHanhProps) {
  const { t, locale } = useT();
  const dichLoi = useLoi();
  const phatHanh = usePhatHanh();
  const [ghiChu, setGhiChu] = useState('');

  useEffect(() => {
    if (!open) return;
    setGhiChu('');
    phatHanh.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const so = soVN((bo.phien_ban_hien_tai ?? 0) + 1, locale);

  return (
    <Dialog open={open} onClose={onClose} title={t('thamDinh.phatHanh.tieuDe', { so })}>
      <div className="space-y-4 pt-2">
        <p className="text-sm text-content-secondary">{t('thamDinh.phatHanh.than', { so })}</p>

        {phatHanh.error && (
          <p className="rounded border border-danger-200 bg-danger-50 p-3 text-sm text-danger-700">
            {dichLoi(phatHanh.error)}
          </p>
        )}

        <Field label={t('thamDinh.phatHanh.ghiChu')} hint={t('thamDinh.phatHanh.ghiChuMo')}>
          {(p) => <Textarea {...p} rows={3} value={ghiChu} onChange={(e) => setGhiChu(e.target.value)} />}
        </Field>

        <div className="flex justify-end gap-2">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button
            variant="primary"
            size="md"
            loading={phatHanh.isPending}
            onClick={() => phatHanh.mutate({ id: bo.id, ghiChu }, { onSuccess: onClose })}
          >
            {t('thamDinh.phatHanh.xacNhan', { so })}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
